import { useContext, useState, useEffect } from "react";
import { useRouter } from "next/router"
import { ProfileContext } from '../../contexts/ProfileContext'
import fetchFastPass from "../fetchFastPass";
import pushGoogleTags from "../pushGoogleTags";
import { WebcastContext } from "../../contexts/WebcastContext";
import useGigIDs from "../useGigIDs";

export interface UseFastPass {
	isFastPassLogin?: boolean,
	stepNo: number,
	loading: boolean,
	fastPassSuccessData: any,
	invalidCreds?: boolean,
	setPassLoginDisabled?: () => void
	setLoading?: (showLoader: boolean) => void,
	setStep: (no: number) => void,
	setInvalidCreds?: (invalid: boolean) => void
}

export const defaultState: UseFastPass = {
	isFastPassLogin: false,
	stepNo: 0,
	loading: false,
	fastPassSuccessData: {},
	setPassLoginDisabled: () => null,
	setLoading: () => null,
	setStep: () => null,
	setInvalidCreds: () => null
}

function getParameterByName(name: string, url = 'window.location.href') {
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const useFastPass = (hostUrl = ''): UseFastPass => {

	const { asPath } = useRouter()
	const { isLoggedIn = false } = useContext(ProfileContext)
	const { isGigCancelled } = useContext(WebcastContext)
	const [invalidCreds, setInvalidCreds] = useState(false)
	const [fastPassSuccessData, setfastPassSuccessData] = useState({});
	const [stepNo, setStep] = useState(0);
	const [isFastPassFailure, setFastPassFailure] = useState(false);
	const [isPassLoginDisabled, setPassIdLoginDisabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const btToken = getParameterByName('bt_tok', asPath)
	const { channelId } = useGigIDs()

	const callFastPass = async () => {

		try {

			setLoading(true);
			const res = await fetchFastPass(hostUrl, {
				channelId: channelId,
				leadId: btToken
			})
			setLoading(false)

			if (res?.status === 200) {

				if (res?.data?.hasBTSESSIONCookie) {

					pushGoogleTags('fastPassExistUserLoggedIn')
					setPassLoginDisabled()

				} else {

					setStep(1);
					setfastPassSuccessData(res.data)
					setFastPassFailure(false)

				}

			} else {

				if (res?.status === 504) {

					pushGoogleTags('lookUpFailedTimeOut')

				} else {

					pushGoogleTags('lookUpFailedError')

				}
				setPassLoginDisabled()

			}

		} catch (error) {

			setLoading(false)
			setPassLoginDisabled()

		}

	}

	const resetFastPassStates = () => {

		setFastPassFailure(false)
		setfastPassSuccessData({})
		setStep(0)

	}

	const setPassLoginDisabled = () => {

		resetFastPassStates()
		setPassIdLoginDisabled(true)

	}

	const isfastPassSuccessDataEmpty = (data: object) => {

		try {

			if (Object.keys(data).length === 0) {

				return true

			}

		} catch (error) {

		}

		return false
	}

	useEffect(() => {

		if (

			btToken && !isLoggedIn && !isGigCancelled &&
			isfastPassSuccessDataEmpty(fastPassSuccessData) && !isFastPassFailure

		) {

			callFastPass()

		}

	}, [isLoggedIn, isGigCancelled])

	return {
		isFastPassLogin: !isPassLoginDisabled && !!btToken && !isLoggedIn,
		stepNo,
		loading,
		fastPassSuccessData,
		setStep,
		setPassLoginDisabled,
		setLoading,
		invalidCreds,
		setInvalidCreds
	}

}

export default useFastPass